import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "inner-wrapper" };
import { i18n } from '@/locales';
import { nextTick, onMounted, ref, watch, } from 'vue';
import { surchargeReasonOptionList } from '@/constants/operationSetting/operationSettingSettingDialog';
import InputRow from '@/components/Form/InputRow.vue';
import { createOperationSettingFormRule } from '@/form/form-rules/operationSetting';
const dialogLc = 'views.operation_setting_dialog.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplyConfigSurcharge',
    emits: ["setFormData"],
    setup(__props, { emit: __emit }) {
        // 운행설정 > 설정할증
        const locales = {
            applicableOrNot: i18n.t(`${dialogLc}applicable_or_not`),
            chargeApply: i18n.t(`${dialogLc}charge_apply`),
            chargeClear: i18n.t(`${dialogLc}charge_clear`),
            reasonForSurcharge: i18n.t(`${dialogLc}reason_for_surcharge`),
            reasonPlaceholder: i18n.t('common.select_field_placeholder', {
                field: i18n.t(`${dialogLc}reason_for_surcharge`),
            }),
        };
        const emit = __emit;
        const formRule = createOperationSettingFormRule();
        const setFormData = (key, value) => {
            nextTick(() => {
                emit('setFormData', key, value);
            });
        };
        // 적용 여부
        const isApply = ref(true);
        watch(() => isApply.value, (v) => {
            setFormData('isApply', v);
        });
        // 할증 사유
        const surchargeReason = ref(null);
        watch(() => surchargeReason.value, (v) => {
            setFormData('surchargeReason', v);
        });
        const resetSurchargeReason = () => {
            surchargeReason.value = null;
        };
        watch(() => isApply.value, () => {
            resetSurchargeReason();
        });
        const init = () => {
            setFormData('isApply', isApply.value);
            setFormData('surchargeReason', surchargeReason.value);
        };
        onMounted(() => {
            init();
        });
        return (_ctx, _cache) => {
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(InputRow, {
                    label: locales.applicableOrNot,
                    "is-vertical-label": "",
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isApply.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isApply).value = $event)),
                            inline: "",
                            dense: "",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                    label: locales.chargeApply,
                                    value: true
                                }, null, 8 /* PROPS */, ["label"]),
                                _createVNode(_component_v_radio, {
                                    label: locales.chargeClear,
                                    value: false
                                }, null, 8 /* PROPS */, ["label"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                (isApply.value)
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 0,
                        label: locales.reasonForSurcharge,
                        "is-vertical-label": "",
                        "is-required": ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                                modelValue: surchargeReason.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((surchargeReason).value = $event)),
                                "item-title": "text",
                                "item-value": "value",
                                variant: "outlined",
                                density: "compact",
                                "bg-color": "white",
                                items: _unref(surchargeReasonOptionList),
                                placeholder: locales.reasonPlaceholder,
                                rules: _unref(formRule).surchargeReason.value
                            }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder", "rules"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
